import { selectors } from './utils/constants';
import { inIframe } from '../../utils/iframe_helper';

class Listings {
  #lightbox;

  constructor() {
    this.listingPictureClickHandler = this.listingPictureClickHandler.bind(this);
    this.reviewListing = this.reviewListing.bind(this);
  }

  expandListingHandler(e) {
    e.stopPropagation();
    const icon = e.currentTarget;
    const listing = icon.closest(selectors.LISTING);
    icon.querySelectorAll('img').forEach(img => img.classList.toggle(selectors.HIDDEN_CLASS));
    listing.classList.toggle(selectors.EXPANDED_CLASS);
  }
  openInNewTab(url) {
    // We need to open new tab only if there is no seo integration feature enabled
    if (!document.querySelector('.js-website-seo-integration-enabled')) {
      const newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.focus();
      }
    } else {
      window.top.location.href = url;
    }
  }
  listingPictureClickHandler(e) {
    if (e.target.classList.contains('listing-video-icon') ||
      e.target.classList.contains('listing-pictures-icon') ||
      e.target.closest('.listing-media-info')) return;
    e.stopPropagation();
    this.openInNewTab(e.currentTarget.querySelector('.listing-pictures-icon').href);
  }
  listingDetailsClickHandler(e) {
    e.stopPropagation();
    window.top.location.href = e.currentTarget.closest('.js-listing-info').querySelector('.js-view-listing-link').href;
  }
  reviewListing(e) {
    if (e.target.closest('.js-listing-info-footer') || e.target.classList.contains('js-listing-info-footer')) return;
    e.stopPropagation();
    this.openInNewTab(e.currentTarget.querySelector('.js-view-listing-link').href);
  }
  unbindEvents() {
    document.querySelectorAll(selectors.LISTING_EXPAND_ICON)
      .forEach(icon => icon.removeEventListener('click', this.expandListingHandler));

    const listingPhotos = document.querySelectorAll('.js-listing-pictures');
    listingPhotos.forEach(photo => {
      photo.removeEventListener('click', this.listingPictureClickHandler);
    });

    document.querySelectorAll('.js-listing-info').forEach(l => l.removeEventListener('click', this.reviewListing));

    document.querySelectorAll('.listing-details').forEach(l => l.removeEventListener('click', this.listingDetailsClickHandler));

    if (!inIframe()) {
      this.#lightbox.destroy();
    }
  }
  bindEvents(gallery) {
    const expandIcons = document.querySelectorAll(selectors.LISTING_EXPAND_ICON);
    expandIcons.forEach(icon => {
      icon.addEventListener('click', this.expandListingHandler);
    });

    const listingPhotos = document.querySelectorAll('.js-listing-pictures');
    listingPhotos.forEach(photo => {
      photo.addEventListener('click', this.listingPictureClickHandler);

      if (inIframe()) {
        if (gallery.dataset.listingGalleryOpenFullscreenInIframe === 'off') {
          const icon = photo.querySelector('.listing-pictures-icon');
          const url = new URL(icon.href);
          url.searchParams.delete('fullscreen');
          icon.href = url.toString();
        }
      }
    });

    document.querySelectorAll('.js-listing-info').forEach(l => l.addEventListener('click', this.reviewListing));
    document.querySelectorAll('.listing-details').forEach(l => l.addEventListener('click', this.listingDetailsClickHandler));

    if (!inIframe()) {
      import('glightbox')
        .then((GLightbox) => {
          this.#lightbox = GLightbox.default({});
        });
    }
  }

  init(gallery) {
    this.bindEvents(gallery);
  }
}

export default Listings;
